'use client';

import { type HTMLAttributes } from 'react';
import { Heading } from '@paypoteam/ui-components';

export interface H1Props extends HTMLAttributes<HTMLHeadingElement> {}

export default function H1({ children, ...props }: H1Props) {
    return (
        <Heading
            type="h1"
            size="6xl"
            {...props}
        >
            {children}
        </Heading>
    );
}
